import {AppPermissions} from '../constants/Mapping';

export class Permission {
  static hasClinicGroupPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.CLINIC_GROUP.NAME]?.[
      permission
    ];
  }
  static hasClinicPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.CLINIC.NAME]?.[
      permission
    ];
  }
  static hasUserPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.USER.NAME]?.[
      permission
    ];
  }
  static hasPatientPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.PATIENT.NAME]?.[
      permission
    ];
  }
  static hasAppointmentPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.APPOINTMENT.NAME]?.[
      permission
    ];
  }
  static hasStatementPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.STATEMENT.NAME]?.[
      permission
    ];
  }
  static hasAdminsPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.ADMIN.NAME]?.[
      permission
    ];
  }
  static hasDashboardPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.DASHBOARD.NAME]?.[
      permission
    ];
  }
  static hasPaymentHistoryPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.PAYMENT_HISTORY.NAME
    ]?.[permission];
  }
  static hasNotificationHistoryPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.NOTIFICATION_HISTORY.NAME
    ]?.[permission];
  }
  static hasActionHistoryPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.ACTION_HISTORY.NAME]?.[
      permission
    ];
  }
  static hasIncomingSmsPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.INCOMING_SMS.NAME]?.[
      permission
    ];
  }
  static hasPatientRecallPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.PATIENT_RECALL.NAME]?.[
      permission
    ];
  }
  static hasAppointmentHistoryPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.APPOINTMENT_HISTORY.NAME
    ]?.[permission];
  }
  static hasCardMachinePermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.CARD_MACHINE.NAME]?.[
      permission
    ];
  }
  static hasEligibilityVerificationPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.ELIGIBILITY_VERIFICATION.NAME
    ]?.[permission];
  }

  static hasCCMPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.CCM.NAME]?.[
      permission
    ];
  }

  static hasPaymentPlanPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.PAYMENT_PLAN.NAME]?.[
      permission
    ];
  }

  static hasFeedBackPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.PATIENT_REVIEW.NAME]?.[
      permission
    ];
  }

  static hasGroupPaymentPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.GROUP_PAYMENTS.NAME]?.[
      permission
    ];
  }

  static hasPriorAuthPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.PRIOR_AUTHORIZATION.NAME
    ]?.[permission];
  }

  static hasScheduledJobPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.SCHEDULED_JOBS.NAME]?.[
      permission
    ];
  }
  static hasMessageInboxPermission(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.MESSAGE_INBOX.NAME]?.[
      permission
    ];
  }

  static hasPatientFormPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.PATIENT_FORMS.NAME]?.[
      permission
    ];
  }

  static hasHolidaysPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.HOLIDAYS.NAME]?.[
      permission
    ];
  }
  static hasGenerateCodesOrReviewCodesPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.PRIOR_AUTHORIZATION.NAME
    ]?.[permission];
  }

  static hasServiceLocationPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.SERVICE_LOCATION.NAME
    ]?.[permission];
  }
  static hasEMRRequestLogsPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[
      AppPermissions.EMR_REQUEST_LOGS.NAME
    ]?.[permission];
  }

  static hasPharmacyClaimPermissions(
    userPermissions: any,
    permission: string,
    groupId: string | number
  ): boolean {
    return !!userPermissions?.[groupId]?.[AppPermissions.CLAIM.NAME]?.[
      permission
    ];
  }
}
